(function (){
    'use strict';

    angular
        .module('services')
        .service('SellerService', SellerService);

    SellerService.$inject = ['$http', 'API_BASE'];

    function SellerService ($http, API_BASE) {
        var service = this;

        service.getAll            = getAll;
        service.getAllVirtualFair = getAllVirtualFair;
        service.getByType         = getByType;
        service.getStaff          = getStaff;

        function getAll() {
            return $http.get(API_BASE + '/expos/sellers/list');
        }

        function getAllVirtualFair () {
            return $http.get(API_BASE + '/expos/sellers/virtualfair/list');
        }

        function getByType(type) {
            return $http.get(API_BASE + '/sellers/type/' + type + '/list');
        }

        function getStaff() {
            return $http.get(API_BASE + '/admusers/getstaff');
        }

    }
})();